module.exports = __webpack_public_path__ + "staticesp/media/Dt9.f8899ad6.jpg";